export type ActionConstant = 'enquiry/fetchAsync' | 'enquiry/fetchForUserAsync';

export class ActionConstants {
    public static readonly fetch: string = 'enquiry/fetchAsync';
    public static readonly fetchForUserAsync: string = 'enquiry/fetchForUserAsync';
    public static readonly updateMyEnquiriesKeyword: string = 'enquiry/updateMyEnquiriesKeyword';
    public static readonly updateMyEnquiriesFilterStatus: string = 'enquiry/updateMyEnquiriesFilterStatus';
    public static readonly updateMyEnquiriesPage: string = 'enquiry/updateMyEnquiriesPage';
    public static readonly updateMyEnquiriesPageSize: string = 'enquiry/updateMyEnquiriesPageSize';
    public static readonly updateMyEnquiriesFrom: string = 'enquiry/updateMyEnquiriesFrom';
    public static readonly updateMyEnquiriesTo: string = 'enquiry/updateMyEnquiriesTo';

    public static readonly updateAllEnquiriesKeyword: string = 'enquiry/updateAllEnquiriesKeyword';
    public static readonly updateAllEnquiriesFilterStatus: string = 'enquiry/updateAllEnquiriesFilterStatus';
    public static readonly updateAllEnquiriesPage: string = 'enquiry/updateAllEnquiriesPage';
    public static readonly updateAllEnquiriesPageSize: string = 'enquiry/updateAllEnquiriesPageSize';
    public static readonly updateAllEnquiriesFrom: string = 'enquiry/updateAllEnquiriesFrom';
    public static readonly updateAllEnquiriesTo: string = 'enquiry/updateAllEnquiriesTo';
}
